import { render, staticRenderFns } from "./TemplateEdit.vue?vue&type=template&id=2361ea30&scoped=true"
import script from "./TemplateEdit.vue?vue&type=script&lang=js"
export * from "./TemplateEdit.vue?vue&type=script&lang=js"
import style0 from "./TemplateEdit.vue?vue&type=style&index=0&id=2361ea30&scoped=true&lang=css"
import style1 from "./TemplateEdit.vue?vue&type=style&index=1&id=2361ea30&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2361ea30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2361ea30')) {
      api.createRecord('2361ea30', component.options)
    } else {
      api.reload('2361ea30', component.options)
    }
    module.hot.accept("./TemplateEdit.vue?vue&type=template&id=2361ea30&scoped=true", function () {
      api.rerender('2361ea30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseTemplate/TemplateEdit.vue"
export default component.exports